"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledReceiptValidation = void 0;
class CancelledReceiptValidation {
    static isValid(entity) {
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // Validate entity.charging_session_attempt_id for existence and correct type.
        if (entity.charging_session_attempt_id == undefined)
            return false;
        if (typeof entity.charging_session_attempt_id !== "string")
            return false;
        return true;
    }
}
exports.CancelledReceiptValidation = CancelledReceiptValidation;
